import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params,Router } from '@angular/router';
import { GlobalService } from 'src/app/services/shared/global.service';
import { ConsigneeService } from 'src/app/services/consignees/consignee.service';
import { CountryService } from 'src/app/services/countries/country.service';
import { ApiResponse } from 'src/app/models/IApiResponse';

@Component({
  selector: 'app-edit-consignee',
  templateUrl: './edit-consignee.component.html',
  styleUrls: ['./edit-consignee.component.css']
})
export class EditConsigneeComponent implements OnInit{
  form!: FormGroup;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  isProcessing: boolean = false;
  submitted: boolean = false;
  countries: any[] = [];
  public consigneeId: string | null = null;
  public consigneeData:any;

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.consigneeId = param['get']('consignee_id')
    })

    if(this.consigneeId){
      this.fetchConsigneeData(this.consigneeId);
      this.fetchCountries();
    }else{
      //Navigate back to consignees list with error
      this.globalService.setGlobalErrorMessage("Unable to select consignee for update!");
      this.router.navigate(['settings/consignees-list']);
    }
  }

  constructor(
    private consigneeService:ConsigneeService,
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private globalService: GlobalService,
    private countryService:CountryService,
  ){
    this.form = this.formBuilder.group({
      consignee_name: ['', Validators.required],
      country_id: ['', Validators.required],
    });
  }

  /**
   * Get consignee data
   * @param consigneeId
   */
  fetchConsigneeData(locationId: string): void {
    this.consigneeService.edit(locationId)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
        }else{
          this.consigneeData = response;
          if(this.consigneeData.status==='no_data' || this.consigneeData.status.length===0){
            this.errorMessage=this.consigneeData.message;
          }
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  fetchCountries():void{
    this.countryService.getAllCountries().subscribe((response: ApiResponse) =>this.countries = response.data);
  }

  handleSubmit():void{
    this.submitted=true;
    this.isProcessing = true;

    if (this.form.valid) {
      const formData = {
        ...this.form.value,
      };

      this.consigneeService.update(formData,this.consigneeId).subscribe(response => {
        if(response.status==='success'){

          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalSuccessMessage(response.message);

          // Redirect back to consignees list
          this.router.navigate(['settings/consignees-list']);
        }else if(response.status==='error'){
          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalErrorMessage(response.message);
        }else{
          this.submitted=false;
          this.isProcessing = false;
          this.errorMessage="Oops! A problem was encountered while processing your request. Please try again or consult your system administrator.";
        }
      },
      error => {
        this.isProcessing = false;
        this.errorMessage=error;
      });
    }else{
      this.isProcessing = false;
    }
  }
}
